import { Youtube } from '@tiptap/extension-youtube';
const TuiYoutube = Youtube.extend({}).configure({
  autoplay: false,
  ccLanguage: 'en',
  interfaceLanguage: 'en',
  allowFullscreen: true,
  disableKBcontrols: true
});

/**
 * Generated bundle index. Do not edit.
 */

export { TuiYoutube };
